import { Controller, useFormContext } from "react-hook-form";
import { ToggleButton, ToggleButtonGroup } from "~/common/mui";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import { C_ON_SECONDARY_CONTAINER, C_OUTLINE, C_SECONDARY_CONTAINER } from "~/common/components/icon/Colors";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import { type SASearchFormFields } from "~/features/salesPartner/components/SearchCard/SalesPartnerSearchBox";
import { trackPartnerFinderSearch } from "~/app/analytics/ga/salesPartner";

interface Props {
  className?: string;
  disabled?: boolean;
}

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  ...getFontStyle(FontSize.LabelLarge),
  borderRadius: "28px",
  border: `1px solid ${C_OUTLINE}`,
  "&.Mui-selected": {
    backgroundColor: C_SECONDARY_CONTAINER,
    color: C_ON_SECONDARY_CONTAINER,
  },
}));

const radiusDropdownMetricValues = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "500", value: 500 },
  { label: "∞", value: -1 },
];

const radiusDropdownImperialValues = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "500", value: 500 },
  { label: "∞", value: -1 },
];

export const RadiusSelectButtonGroup = ({ className, disabled }: Props) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext<SASearchFormFields>();
  const useImperial = window.SCHA.config.isSPFImperial;

  const radiusDropdownValues = useImperial ? radiusDropdownImperialValues : radiusDropdownMetricValues;

  return (
    <>
      <div className="f-label-color mt-2 mb-2">{t("partnerFinder.filter.radius")}</div>
      <Controller
        name="radius"
        control={control}
        defaultValue={100}
        rules={{ required: true }}
        render={({ field: { value, onChange, onBlur } }) => (
          <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(event, newValue) => {
              if (newValue !== null) {
                onChange(newValue);
                trackPartnerFinderSearch(getValues(), "Filter Applied", "Click", undefined, "Radius");
              }
            }}
            fullWidth
          >
            {radiusDropdownValues.map((radius) => (
              <StyledToggleButton key={radius.value} value={radius.value} disabled={disabled}>
                {radius.label.split(" ")[0]}
              </StyledToggleButton>
            ))}
          </ToggleButtonGroup>
        )}
      />
    </>
  );
};
